import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChild } from '@angular/core';
import { Splitter } from 'primeng/splitter';

import { injectSidebarContext } from '../sidebar-context';
import { SidebarExpandedDirective, SidebarIconDirective } from '../sidebar-slot.directive';

@Component({
    selector: 'adv-sidebar-footer',
    templateUrl: './sidebar-footer.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgTemplateOutlet, Splitter],
    host: { class: 'mt-auto block shrink-0' },
})
export class SidebarFooterComponent {
    private readonly _sidebar = injectSidebarContext();

    protected readonly expandedContent = contentChild.required(SidebarExpandedDirective);
    protected readonly iconContent = contentChild.required(SidebarIconDirective);
    protected readonly iconOnly = this._sidebar.iconOnly;
}
